class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&section_id=predictive-search&resources[type]=query,product,collection,page&options[prefix]=last`)
      .then((response) => {
        
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }

        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        let lowerString = searchTerm.toLowerCase();
        if(lowerString == "return") {
          // Convert the HTML string into a jQuery object
          let $markup = $(text);
          
          // Add a new <li> to the <ul> inside the markup
          if($markup.find('#predictive-search-results ul').length > 0) {
            $markup.find('#predictive-search-results ul').append('<li><a href="https://returns.shopfavoritedaughter.com/">Start Your Return</a></li>');
          } else {
            $markup.find('#predictive-search-results').append('<ul class="return_cls" role="listbox" aria-labelledby="predictive-search-products"><li role="option"><a href="https://returns.shopfavoritedaughter.com/">Start Your Return</a></li></ul>');
          }
          // Convert back to HTML string if needed
          var resMarkupreturn = $markup.prop('innerHTML');
        } else {
          var resMarkupreturn = resultsMarkup;
        }
        this.predictiveSearchResults.innerHTML = resMarkupreturn;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
   // this.predictiveSearchResults.style.display = 'block';
    this.predictiveSearchResults.style.visibility = 'visible';
  }

  close() {
  //  this.predictiveSearchResults.style.display = 'none';
    this.predictiveSearchResults.style.visibility = 'hidden';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
